module.exports = __webpack_public_path__ + "img/WZ.d20ad939.svg";